import { Box, Container, styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const LoginContainer = styled(Container)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
    maxWidth: '844px',
    margin: '0 auto',
    padding: '0 20px',
});

export const LoginWrapper = styled(Box)({
    padding: '40px',
    backgroundColor: '#fff',
    borderRadius: '16px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
    width: '100%',
    maxWidth: '440px'
});

export const LogoContainer = styled(Box)({
    marginBottom: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    marginTop: '60px',

    '& img': {
        height: '50px',
        width: '50.865px',
        flexShrink: '0',
        marginRight: '10px',
    },
    '& .MuiTypography-h1': {
        fontSize: '32px',
        fontWeight: '700',
    },
});

export const FormContainer = styled('form')({
    width: '100%',
    marginTop: '40px'
});

export const UsernameContainer = styled(Box)({
    marginBottom: '24px',
    '& .MuiTextField-root': {
        marginBottom: '16px',
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px'
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px'
        },
        '& .MuiInputBase-input': {
            fontSize: '15px'
        }
    }
});

export const LoginButton = styled('button')({
    width: '100%',
    padding: '12px',
    backgroundColor: '#0058A0',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    marginTop: '24px',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: '#153366'
    },
    '&:disabled': {
        backgroundColor: '#cccccc',
        cursor: 'not-allowed'
    }
});

export const ForgotPasswordLink = styled(Link)({
    color: '#2A81D0',
    textDecoration: 'none',
    display: 'block',
    textAlign: 'right',
    fontSize: '14px',
    fontWeight: '500',
    '&:hover': {
        textDecoration: 'underline'
    }
});
